import React, { useState } from 'react';
import {
  AboutContainer,
  AboutContent,
  AboutH1,
  AboutP,
  AboutElem,
  AboutSubtext,
} from './About';

const About = () => {
  //   const [hover, setHover] = useState(false);

  //   const onHover = () => {
  //     setHover(!hover);
  //   };

  return (
    <AboutContainer id="about">
      <AboutContent>
        <div>
          <AboutH1>Много лет качества и комфорта</AboutH1>
          <AboutSubtext>
            ООО «МЭТР» вышел на рынок 18 июля 2011 года. С момента основания мы
            растем и развиваемся для того, чтобы радовать своих клиентов.
          </AboutSubtext>
        </div>
        <div>
          <AboutH1>Какие наши преимущества?</AboutH1>
          <AboutP>
            <AboutElem>индивиуальный подход к каждому клиенту</AboutElem>
            <AboutElem>высочайшее качество работ</AboutElem>
            <AboutElem>высочайшее качество материалов и изделий</AboutElem>
            <AboutElem>
              высококвалифицированные специалисты с многолетним опытом
            </AboutElem>
            <AboutElem>приемлемые цены</AboutElem>
            <AboutElem>большой опыт с крупными заказчиками</AboutElem>
          </AboutP>
        </div>
      </AboutContent>
    </AboutContainer>
  );
};

export default About;
